// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-nav {
  background: var(--vl-bg-dark) !important;
}

ion-nav * {
  background: none;
}

.modal-base-wrapper {
  height: 80vh;
}`, "",{"version":3,"sources":["webpack://./src/shared/components/modal-base/modal-base.component.scss"],"names":[],"mappings":"AAAA;EACI,wCAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,YAAA;AACJ","sourcesContent":["ion-nav {\n    background: var(--vl-bg-dark) !important;\n}\n\nion-nav * {\n    background: none;\n}\n\n.modal-base-wrapper {\n    height: 80vh;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
